import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var p1_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section2 ul li h4').each(function() { //遍历相同样式名的元素
    var p1 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p1_max = p1 > p1_max ? p1 : p1_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section2 ul li h4').height(p1_max); //给每一个元素设置相同的高度	

 let rowspanMap = {};

$(".table table tr").each(function(rowIndex){

    let colIndex = 0;

    $(this).children("td,th").each(function(){

        while(rowspanMap[colIndex] > 0){
            rowspanMap[colIndex]--;
            colIndex++;
        }

        let rowspan = parseInt($(this).attr("rowspan")) || 1;
        let colspan = parseInt($(this).attr("colspan")) || 1;

        if(rowspan > 1){
            for(let i=0;i<colspan;i++){
                rowspanMap[colIndex+i] = rowspan-1;
            }
        }

        /* 第一行 */
        if(rowIndex == 0){
            $(this).addClass("table-head")
        }

        /* 第一列 */
        if(colIndex == 0){
            $(this).addClass("table-head")
        }

        colIndex += colspan;

    });

    /* 行颜色 */
    if(rowIndex > 0){

        if(rowIndex % 2 == 1){
            $(this).css({
                background:"#fff",
                color:"#333",
            });
        }else{
            $(this).css("background","#f2f2f2");
        }

    }

});

var history = new Swiper(".section5 .mySwiper", {
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",
    },
    pagination: {
        el: ".section5 .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: 20,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});
 